// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3ljBl","header":"MergedInvoice_header__Zanwe"};